// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1nkZf","title":"FrontImage_title__1tTnI"};